import type { FeedItemDto } from './feed.dto';
import { z } from 'zod';

export interface MemberTransferReasonDto {
  id: number;
  text: string;
  detailType?: string;
  detailQuestion?: string;
  detailLabel?: string;
  sortOrder: number;
}

export interface MemberTransferRequestDto {
  id: number;
  memberId: string;
  /**
   * Groups member transfer rows created by the same bulk submission.
   */
  bulkRequestId?: number;
  originatingGuideId: string | null;
  receivingGuideId: string;
  receivingGuideTeamId: number;
  creatorId: string;
  auditorId?: string;
  transferReasonId: number;
  stringDetail?: string;
  numericDetail?: number;
  timestampDetail?: number;
  approvedAt?: number;
  deniedAt?: number;
  effectiveAt?: number;
  commentToReceivingGuide?: string;
  auditorComment?: string;
  transferReason?: MemberTransferReasonDto;
  deletedAt?: number;
}

export const AuditMemberTransferRequestFormSchema = z
  .object({
    approval: z.enum(['deny', 'approve']),
    receivingGuideId: z.string(),
    effectiveAt: z.string(),
    auditorComment: z.string(),
  })
  .strict();

export type AuditMemberTransferRequestFormDto = z.infer<
  typeof AuditMemberTransferRequestFormSchema
>;

export interface MemberTransferDataView {
  feedItem: FeedItemDto;
  memberTransferRequest: MemberTransferRequestDto;
}

export const MemberTransferRequestFormSchema = z
  .object({
    memberId: z.string(),
    originatingGuideId: z.string().optional().nullable(),
    receivingGuideId: z.string().nonempty('Required'),
    creatorId: z.string().optional(),
    clientId: z.number().optional(),
    transferReasonId: z.coerce.number(),
    stringDetail: z.string().optional(),
    numericDetail: z.coerce.number().optional().nullable(),
    timestampDetail: z.string().optional().nullable(),
    commentToReceivingGuide: z.string().nonempty('Required'),
    approval: z.enum(['deny', 'approve']).optional().nullable(),
    effectiveAt: z.number().optional(),
  })
  .strict();

export type MemberTransferRequestFormType = z.infer<
  typeof MemberTransferRequestFormSchema
>;

export type MemberTransferRequestFormDto = z.infer<
  typeof MemberTransferRequestFormSchema
>;
